import { RootState } from '../rootReducer';
import {
  CampaignReview,
  ICampaign,
  CampaignAnalytics,
  CampaignPagination,
} from '../../types/campaigns/campaigns.types';

// Campaign selectors
export const selectCampaignsLoading = (state: RootState): boolean =>
  state.campaigns.loading;
export const selectCampaignsError = (state: RootState): string | null =>
  state.campaigns.error;
export const selectCampaigns = (state: RootState): ICampaign[] =>
  state.campaigns.campaigns;
export const selectCampaignsPagination = (
  state: RootState
): CampaignPagination => state.campaigns.pagination;
export const selectSelectedCampaign = (state: RootState): ICampaign | null =>
  state.campaigns.selectedCampaign;
export const selectCampaignSuccess = (state: RootState): boolean =>
  state.campaigns.success;
export const selectCreateCampaignLoading = (state: RootState): boolean =>
  state.campaigns.createLoading;
export const selectUpdateCampaignLoading = (state: RootState): boolean =>
  state.campaigns.updateLoading;
export const selectPublishCampaignLoading = (state: RootState): boolean =>
  state.campaigns.publishLoading;
export const selectPublishCampaignSuccess = (state: RootState): boolean =>
  Boolean(state.campaigns.publishSuccess);
export const selectReviewCampaignLoading = (state: RootState): boolean =>
  state.campaigns.reviewLoading;
export const selectReviews = (state: RootState): CampaignReview | null =>
  state.campaigns.reviews;
export const selectDeleteCampaignLoading = (state: RootState): boolean =>
  Boolean(state.campaigns.deleteLoading);
export const selectDeleteCampaignSuccess = (state: RootState): boolean =>
  Boolean(state.campaigns.deleteSuccess);

// Analytics selectors
export const selectCampaignAnalyticsLoading = (state: RootState): boolean =>
  state.campaigns.analyticsLoading;
export const selectCampaignAnalytics = (
  state: RootState
): CampaignAnalytics | null => state.campaigns.analytics;

// Contact Counts selectors
export const selectCampaignContactCounts = (state: RootState) =>
  state.campaigns.contactCounts;

export const selectCampaignContactCountsLoading = (state: RootState) =>
  state.campaigns.contactCountsLoading;

export const selectCampaignContactCountsError = (state: RootState) =>
  state.campaigns.contactCountsError;

export const selectPauseCampaignError = (state: RootState) =>
  state.campaigns.pauseCampaignError;

export const selectPauseCampaignSuccess = (state: RootState) =>
  state.campaigns.pauseCampaignSuccess;

export const selectPauseCampaignLoading = (state: RootState) =>
  state.campaigns.pauseCampaignLoading;
